import React from 'react';

/**
 * Context supports multiple timezones
 */
export const TimezoneContext = React.createContext({
  timezone: null,
  changeTimezone: () => {},
});
